import { AudioMutedOutlined, SendOutlined, SmileOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, Flex, Form, InputNumber, Popconfirm, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Text from 'antd/es/typography/Text';
import EmojiPicker, { EmojiClickData } from 'emoji-picker-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { ChatWrapp } from './ChatWrapp';
import { ChatList } from './ChatList';

class _ChatBlock extends Component<IRootStoreProps> {
  formRef = React.createRef<any>();
  messageListRef = React.createRef<HTMLDivElement>();

  state = {
    isScrolledToBottom: true,
    isLoadingMessages: false,
    hasMoreMessages: true,
    oldScrollHeight: 0,
    muteMinute: 10,
  };

  handleSendMessage = async (values: any) => {
    await this.props.store.user.handleSendMessage(values.message);

    this.formRef.current?.setFieldsValue({
      message: '',
    });
  };

  handleEmojiClick = (emojiObject: EmojiClickData) => {
    const currentValue = this.formRef.current?.getFieldValue('message') || '';
    this.formRef.current?.setFieldsValue({
      message: currentValue + emojiObject.emoji,
    });
    this.props.store.user.toggleEmojiPicker();
  };

  render(): React.ReactNode {
    const {
      toggleEmojiPicker,
      showEmojiPicker,
      chatMessageList,
      usersOnline,
      setRecipient,
      recipient,
      chatMessagesLoadMore,
      setMute,
      isAdmin,
      isModeratorChat,
    } = this.props.store.user;
    return (
      <ChatWrapp usersOnline={usersOnline}>
        <ChatList
          chatMessageList={chatMessageList}
          setRecipient={setRecipient}
          chatMessagesLoadMore={chatMessagesLoadMore}
        />
        <div style={{ position: 'relative' }}>
          {showEmojiPicker && (
            <div style={{ position: 'absolute', bottom: '10px', zIndex: 10 }}>
              <EmojiPicker
                width={300}
                height={300}
                searchDisabled
                skinTonesDisabled
                className="custom-emoji-picker"
                onEmojiClick={this.handleEmojiClick}
              />
            </div>
          )}
          <div style={{ height: 20, marginBottom: 10 }}>
            {recipient?.recipientName && (
              <>
                <Text type={'secondary'}>{`для: `}</Text>
                <Text type={'success'}>{recipient?.recipientName}</Text>
              </>
            )}
          </div>
          <Form ref={this.formRef} onFinish={this.handleSendMessage} initialValues={{ message: '' }}>
            <Form.Item
              name="message"
              rules={[
                { required: true, message: 'Введите текст сообщения!' },
                {
                  validator: (_, value) =>
                    value && value.trim() ? Promise.resolve() : Promise.reject('Сообщение не должно быть пустым'),
                },
                { max: 100, message: 'Сообщение не может быть длиннее 100 символов!' },
              ]}
            >
              <TextArea
                showCount
                maxLength={100}
                placeholder="Введите сообщение..."
                style={{ height: 120, resize: 'none' }}
                onKeyDown={e => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    this.formRef.current?.submit();
                  }
                }}
              />
            </Form.Item>
            <Flex justify={'space-between'}>
              <Row>
                <Button type="text" shape="circle" icon={<SyncOutlined />} />
                <Button type="text" shape="circle" icon={<SmileOutlined />} onClick={toggleEmojiPicker} />
                {(isAdmin || isModeratorChat) && (
                  <Popconfirm
                    title={'Запрет сообщений'}
                    description={
                      <Flex vertical>
                        <Text type={'secondary'} style={{ marginBottom: 10 }}>
                          {'На сколько минут Вы хотите замьютить пользователя?'}
                        </Text>
                        <InputNumber onChange={e => this.setState({ muteMinute: e })} value={this.state.muteMinute} />
                      </Flex>
                    }
                    onConfirm={() => setMute(this.state.muteMinute)}
                    okText="Запретить"
                    cancelText="Нет"
                  >
                    <Button
                      disabled={!recipient?.recipientId}
                      type="text"
                      shape="circle"
                      icon={<AudioMutedOutlined />}
                    />
                  </Popconfirm>
                )}
              </Row>
              <Button type="primary" icon={<SendOutlined />} htmlType={'submit'} />
            </Flex>
          </Form>
        </div>
      </ChatWrapp>
    );
  }
}

export const ChatBlock: WithoutStore = withStore(observer(_ChatBlock));
